"use strict";
export var LiquidityEventName = /* @__PURE__ */ ((LiquidityEventName2) => {
  LiquidityEventName2["ADD_LIQUIDITY_SUBMITTED"] = "Add Liquidity Submitted";
  LiquidityEventName2["COLLECT_LIQUIDITY_SUBMITTED"] = "Collect Liquidity Submitted";
  LiquidityEventName2["MIGRATE_LIQUIDITY_SUBMITTED"] = "Migrate Liquidity Submitted";
  LiquidityEventName2["REMOVE_LIQUIDITY_SUBMITTED"] = "Remove Liquidity Submitted";
  LiquidityEventName2["SELECT_LIQUIDITY_POOL_FEE_TIER"] = "Select Liquidity Pool Fee Tier";
  LiquidityEventName2["TRANSACTION_MODIFIED_IN_WALLET"] = "Transaction Modified in Wallet";
  return LiquidityEventName2;
})(LiquidityEventName || {});
